import { render, staticRenderFns } from "./CardColumManager.vue?vue&type=template&id=1358213e"
import script from "./CardColumManager.vue?vue&type=script&lang=js"
export * from "./CardColumManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports